export default {
    'LAMINA_DE_TRADE': 1,
    'CARTA_DE_VENDAS': 2,
}
